import { render, staticRenderFns } from "./registeringOrganization.vue?vue&type=template&id=386792b5&scoped=true&"
import script from "./registeringOrganization.vue?vue&type=script&lang=js&"
export * from "./registeringOrganization.vue?vue&type=script&lang=js&"
import style0 from "./registeringOrganization.vue?vue&type=style&index=0&id=386792b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386792b5",
  null
  
)

export default component.exports